<svelte:options tag="and-modal" ></svelte:options>
<link rel="stylesheet" href="and-component-styles.css" {style_disabled}/>

<script>
import { createEventDispatcher } from 'svelte';
import { get_current_component } from "svelte/internal"
import eventDispatcher from '../../EventDispatcher';

export let overidestyle = false;
$: style_disabled = overidestyle ? null : true;

let class_name = '';

export  { class_name as class };

export let isopen = true;

export let id = 'and-modal';

function close() {
    isopen = false;
    onClose()
}

function keydown(e) {
    e.stopPropagation();
    if (e.key === "Escape") {
        close();
    }
}

const component = get_current_component()
const dispatch = createEventDispatcher();  

const onClose = event => {
    dispatch('close', event);
    eventDispatcher.dispatchCustomEvent(component, event, 'close');
  };

</script>

<style type="text/scss" lang="scss">
    @import '../../global.scss';
    .modal {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center; 
        font-family: "Poppins", sans-serif;
    }

    .backdrop {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: darkgray;
    }

    .header h1 {
        margin: 0;
    }

    .content-wrapper {
        background: white;
        border: 1px solid black;
        border-radius: toRem(4px);
        flex-basis: 32em;
        position: relative;
        padding: toRem(15px);
    }

    .close-button{
        float: right;
        background:none;
        outline: none;
        border-radius: toRem(5px);
    }
    .content {
        max-height: toRem(400px);
        max-width: toRem(600px);
        overflow: auto;
    }
    .footer {
        display: flex;
        justify-content: flex-end;

        .footer-content{
            padding: 15px;
        }
    }

</style>
{#if isopen}
    <div id={id} data-testid="custom-modal" class={['modal', class_name].join(' ')}  on:keydown={keydown} tabindex={0}>
        <div data-testid="custom-modal-backdrop" class="backdrop" on:click={close} />
        <div class="content-wrapper"> 
            <div data-testid="custom-modal-header" class="header">
                <button class="close-button" on:click={close}>X</button>
                <slot name="header">
                    <!-- fallback -->
                    <div>
                        <h1>Heading</h1>
                    </div>
                </slot>
            </div>

            <div data-testid="custom-modal-content" class="content">
                <slot name="content" >
                    <div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique, magni earum ut ex
                        totam corporis unde incidunt deserunt, dolorem voluptatum libero quia. Maiores,
                        provident error vel veritatis itaque nemo commodi.</p>

                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique, magni earum ut ex
                        totam corporis unde incidunt deserunt, dolorem voluptatum libero quia. Maiores,
                        provident error vel veritatis itaque nemo commodi.</p>

                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique, magni earum ut ex
                        totam corporis unde incidunt deserunt, dolorem voluptatum libero quia. Maiores,
                        provident error vel veritatis itaque nemo commodi.</p>

                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique, magni earum ut ex
                        totam corporis unde incidunt deserunt, dolorem voluptatum libero quia. Maiores,
                        provident error vel veritatis itaque nemo commodi.</p>
                    </div>
                </slot> 
            </div>

            <div data-testid="custom-modal-footer" class="footer">
                <slot name="footer" >
                    <div class="footer-content">
                        <button>Sample</button>
                        <button>Sample 2</button>
                    </div>
                </slot> 
            </div>
        </div>
    </div>
{/if}
